import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { View } from "@aws-amplify/ui-react";
import { BsChevronRight, BsChevronDown } from "react-icons/bs";

export const ConfigGroup = ( { className, label, children } ) => {
  const [isOpen, setIsOpen] = useState( false )

  return (
    <View className="cp-grp" >
      <View
        width="16px"
        height="16px"
        margin="xs"
        right="0"
        style={{cursor: "pointer"}}
        onClick={() => { setIsOpen( !isOpen ) }}
      >
        {
          isOpen ? (
            <BsChevronDown size={16} />
          ) : (
            <BsChevronRight size={16} />
          )
        }
      </View>

      <View className="cp-grp-ctr" >
        <View
          grow={1}
          shrink={1}
          marginBottom="xs"
          className="cp-grp-lbl"
          onClick={() => { setIsOpen( !isOpen ) }}
        >
          {label}
        </View>

        { isOpen ? children : null }
      </View>
    </View>
  )
}

ConfigGroup.propTypes = {
  configProp: PropTypes.string,
  label: PropTypes.string,
  staticTypes: PropTypes.array,
  isDynamic: PropTypes.bool
}
